import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { billReadyRoutes } from './routes';

/** The most bills property-service answers in one call; a larger page is sent in batches of this size. */
export const BILL_READY_BATCH = 200;

/** One of a bill's utilities, asked about by its period end. `key` comes back on its answer. */

/**
 * Where a ready date came from: the utility's own bills, its provider's other bills, a day of the month someone set,
 * or nothing at all, in which case the date is only the period end.
 */

/** When a bill was ready to collect (LB-6032): its period end plus the lag learned from the utility's earlier bills. */

export class BillReady {
  constructor() {
    _defineProperty(this, "routes", billReadyRoutes);
  }
  /**
   * Ready dates for up to {@link BILL_READY_BATCH} bill utilities. Answers for properties the caller cannot see are
   * left out, not refused.
   */
  async postForBills(bills, options) {
    const resp = await requestService('property').post(this.routes.forBills, {
      bills
    }, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}